// eslint-disable-next-line import/prefer-default-export
export const validateEmail = (email) => {
  // Regular expression for a basic email validation
  const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return regex.test(email);
};
